import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { supabase } from '../lib/supabase'

export default function Home() {
  const [loggedIn, setLoggedIn] = useState<boolean | null>(null)

  useEffect(() => {
    supabase.auth.getUser().then(({ data }) => {
      setLoggedIn(!!data.user)
    })
  }, [])

  if (loggedIn === null) {
    return <div className="min-h-dvh bg-gray-950" />
  }

  return (
    <div className="min-h-dvh bg-gray-950 flex flex-col items-center justify-center gap-6">
      <h1 className="text-white text-4xl font-bold tracking-tight">h3r</h1>
      <Link
        to={loggedIn ? '/manage' : '/login'}
        className="text-sm text-gray-400 hover:text-white transition-colors duration-200"
      >
        {loggedIn ? 'Mine gallerier →' : 'Logg inn'}
      </Link>
    </div>
  )
}
